import {
  Box,
  Text,
  FormControl,
  // FormErrorMessage,
  FormLabel,
  Switch as ChakraSwitch,
} from '@chakra-ui/react';
import { Select } from 'components/Form';
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const RoomTypeSwitch = ({ name = 'roomType', ...inputProps }) => {
  const { t } = useTranslation();

  const roomTypes = [
    {
      label: 'PUBLIC',
      value: 0,
    },
    {
      label: 'PRIVATE',
      value: 1,
    },
    {
      label: 'PERM',
      value: 2,
    },
  ]

  return (
    <Select
      name={name}
      label={t('Room type')}
      options={roomTypes}
    />
    // <Box w="full" zIndex={0}>
    //   <Text fontWeight={500} mb={1}>
    //     {t('Room type')}
    //   </Text>
    //   <FormControl display="flex" alignItems="center">
    //     <Controller
    //       control={control}
    //       name={name}
    //       defaultValue={false}
    //       render={({ field: { onChange, value, ref } }) => (
    //         <ChakraSwitch
    //           onChange={(e) => onChange(e.target.checked ? 1 : 0)}
    //           ref={ref}
    //           isChecked={value}
    //           colorScheme="green"
    //           size="sm"
    //           {...inputProps}
    //         />
    //       )}
    //     />
    //     <FormLabel ml={2} mb={0} htmlFor={name} fontSize="14px">
    //       {t('Public / private')}
    //     </FormLabel>
    //   </FormControl>
    // </Box>
  );
};

export default RoomTypeSwitch;
